import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import "firebase/compat/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAz6ZzXQmahvVcEdNSma1FONiG4Rr20Euk",
  authDomain: "gemlogs-app.firebaseapp.com",
  projectId: "gemlogs-app",
  storageBucket: "gemlogs-app.appspot.com",
  messagingSenderId: "439913861495",
  appId: "1:439913861495:web:031dbf5ace3f85ee1a1172"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const uploadImage = async (image, type) => {
    try {
      const timestamp = Date.now();
      const imageName = `${timestamp}_${image.name}`;
      let folder = type || "user_projects";
      const storageRef = firebase.storage().ref().child(folder);
      const imageRef = storageRef.child(imageName);
      await imageRef.put(image);
      const imageUrl = await imageRef.getDownloadURL();
      return imageUrl;
    } catch (error) {
      return "";
    }
  };
  